import { Foundation } from 'foundation-sites/js/foundation.core';
import { ResponsiveAccordionTabs } from 'foundation-sites/js/foundation.responsiveAccordionTabs';
import Swiper from 'swiper';
import { Navigation, Scrollbar } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

export class ProductCategory {
    constructor (target) {
      this.section = target;
    }

    init () {
      if (!this.section || CMS.editMode) {
        return;
      }

      this.initAccordionTabs();

      const categoriesSelector = '#product-category-tabs';
      const tabsSelector = this.section.querySelector('.tabs-panel.is-active');

      if (tabsSelector) {
        this.initProductsSlider(tabsSelector)
      }

      $(document).on('change.zf.tabs', categoriesSelector, () => {
        const activeTabId = $(categoriesSelector)
          .find('.categories-item.is-active .categories-item-wrap')
          .attr('href')
        const selectedTabSlider = this.section.querySelector(activeTabId);

        this.initProductsSlider(selectedTabSlider)
      });

      $(document).on('down.zf.accordion', categoriesSelector, () => {
        const accordionActiveItem = this.section.querySelector('.accordion-item.is-active');

        this.initProductsSlider(accordionActiveItem)
      });

      this.loading(false);
    }

    initAccordionTabs() {
      // eslint-disable-next-line
      $ = Foundation.addToJquery($)
      Foundation.plugin(ResponsiveAccordionTabs, 'ResponsiveAccordionTabs');

      $('#product-category-tabs').foundation();
    }

    initProductsSlider(slider) {
      const sliderSelector = slider.querySelector('.products-slider');
      const sliderElement = sliderSelector.querySelector('.swiper');

      const config = {
        slidesPerView: 1,
        spaceBetween: 28,
        enabled: true,
        a11y: {
          slideRole: 'presentation',
          slideLabelMessage: '',
        },
        breakpoints: {
          640: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 2,
            spaceBetween: 32,
          },
        },
        navigation: {
          nextEl: sliderSelector.querySelector('.swiper-button-next'),
          prevEl: sliderSelector.querySelector('.swiper-button-prev'),
        },
        scrollbar: {
          el: sliderSelector.querySelector('.swiper-scrollbar'),
          draggable: true,
        },
        modules: [Navigation, Scrollbar],
      };

      new Swiper(sliderElement, config);
    }

    loading(isLoading = true) {
      this.section.classList.toggle('loading', isLoading);
    }
}
